



































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Nav from '@/services/Navigation';
import orderby from 'lodash/orderBy';

@Component({
	components: {
	}
})
export default class NavListTable extends Vue {
	@Prop() items!: Nav[];
	isLoaded = true;
	search = '';

	get displayNavs() {
		const lower = (nav: Nav) => {
			return nav.name ? nav.name.toLowerCase() : nav.name;
		};
		return orderby(this.items, [lower]);
	}

	searchHighlight(value: string|number): string | number  {
		if (!this.search.length || value === null) {
			return value;
		}
		return value.toString().replace(
			RegExp(this.search, 'ig'),
			(matchText) => '<strong style="color: #000;">' + matchText + '</strong>'
		);
	}

}
